
































/* eslint-disable @typescript-eslint/camelcase */

import Vue from "vue";
import { State, Action } from "vuex-class";
import Component from "vue-class-component";
import { FacebookState } from "../../../store/facebook";
const namespace = "facebook";

@Component({
  props: {
    showAdd: Boolean
  }
})
export default class Audiences extends Vue {
  @State("facebook") facebook: FacebookState;
  @Action("fetchAudiences", { namespace }) fetchAudiences: any;

  loading = false;
  title = "";
  headers = [
    {
      text: "Name",
      value: "name",
      sortable: false
    },
    {
      text: "Status",
      value: "status",
      sortable: false
    },
    {
      text: "add",
      value: "add",
      sortable: false
    }
  ];

  created() {
    this.fetchAudiences({ accountId: this.$route.params.accountId });
  }
}
